import { api } from '@/services/api/main/axios';
import { StatusEnum } from '@/services/models/Enums';

export type GetCampaignsParams = {
  limit?: number;
  status?: StatusEnum.active;
  search?: string;
  workspaceIds?: string[];
  orderBy?: string;
  orderDirection?: string;
};

export const getCampaignsApiRequest = async (
  params: GetCampaignsParams = {},
): Promise<Bemob.Campaign[]> => {
  const res = await api.get<{ payload: Bemob.Campaign[] }>('campaigns', { params });
  return res.data.payload;
};

export const getCampaignApiRequest = async (id: string): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>(`campaigns/${id}`);
  return res.data.payload;
};

export const postCreateCampaignApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('campaigns', payload);
  return res.data.payload;
};

export const putUpdateCampaignApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(`campaigns/${id}`, payload);
  return res.data.payload;
};

export const putCampaignsBulkUpdateApiRequest = async (
  workspaceId: string,
  payload: object,
): Promise<void> => {
  await api.put(`campaigns/workspace/${workspaceId}/bulk-update`, payload);
};

export const postCampaignUpdateCostApiRequest = async (
  id: string,
  payload: object,
): Promise<void> => {
  await api.post(`campaigns/${id}/update-cost`, payload);
};

export const getCampaignsCountApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<{ count: number }> => {
  const res = await api.get<{ payload: { count: number } }>('campaigns/count', { params });
  return res.data.payload;
};

export type CampaignExternalStatusPayload = {
  status?: 'play' | 'stop';
};

export const putCampaignExternalStatusApiRequest = async (
  id: string,
  payload: CampaignExternalStatusPayload,
): Promise<{ externalStatus?: unknown }> => {
  const res = await api.put<{ payload: { externalStatus?: unknown } }>(
    `/v2/campaigns/${id}/external-status`,
    payload,
  );
  return res.data.payload;
};
